import useIsMobile from '@/helpers/commonHooks/useIsMobile'
import PrivacyPageMobile from './components/PrivacyPageMobile/PrivacyPageMobile'
import PrivacyPagePc from './components/PrivacyPagePc/PrivacyPagePc'
import { commonUtils } from '@/helpers/commonUtils'

const assets = (no: number) => {
  return commonUtils.getImagePath(`privacyPage/order-${no}.png`)
}

export const ORDER_ICONS = [
  '',
  assets(1),
  assets(2),
  assets(3),
  assets(4),
  assets(5),
  assets(6),
  assets(7),
  assets(8),
  assets(9),
  assets(10),
  assets(11),
  assets(12),
]


function PrivacyPage() {
  const isMobile = useIsMobile()
  return isMobile ? <PrivacyPageMobile /> : <PrivacyPagePc />
}

export default PrivacyPage
